class RecentlyViewedProducts extends HTMLElement {
  static STORAGE_KEY = 'recently_viewed_products';

  connectedCallback() {
    const currentHandle = this.dataset.productHandle;
    const maxItems = parseInt(this.dataset.maxItems, 10) || 4;
    const grid = this.querySelector('[data-recently-viewed-grid]');

    let stored = [];
    try {
      stored = JSON.parse(localStorage.getItem(RecentlyViewedProducts.STORAGE_KEY)) || [];
    } catch (error) {
      stored = [];
    }

    const others = stored.filter((handle) => handle !== currentHandle).slice(0, maxItems);

    const updated = [currentHandle, ...stored.filter((handle) => handle !== currentHandle)].slice(0, 12);
    try {
      localStorage.setItem(RecentlyViewedProducts.STORAGE_KEY, JSON.stringify(updated));
    } catch (error) {
      // localStorage unavailable (private browsing, etc.) - fail silently
    }

    if (others.length === 0 || !grid) return;

    Promise.all(
      others.map((handle) =>
        fetch(`/products/${handle}?view=recently-viewed-card`)
          .then((response) => (response.ok ? response.text() : null))
          .catch(() => null)
      )
    ).then((results) => {
      const fragment = document.createDocumentFragment();

      results.forEach((html) => {
        if (!html) return;
        const template = document.createElement('template');
        template.innerHTML = html.trim();

        template.content.querySelectorAll('link[rel="stylesheet"]').forEach((link) => {
          const href = link.getAttribute('href');
          if (href && !document.querySelector(`link[href="${href}"]`)) {
            document.head.appendChild(link.cloneNode(true));
          }
        });

        const cardContent = template.content.querySelector('.card-wrapper');
        if (!cardContent) return;

        const li = document.createElement('li');
        li.className = 'grid__item';
        li.appendChild(cardContent);
        fragment.appendChild(li);
      });

      if (fragment.childElementCount > 0) {
        grid.appendChild(fragment);
        this.removeAttribute('hidden');
      }
    });
  }
}

customElements.define('recently-viewed-products', RecentlyViewedProducts);
